/**
 *
 * @type {number}
 */
const BASE_FONT_SIZE_PX = getBaseFontSize();

/**
 *
 * @return {number}
 */
export function getBaseFontSize() {
  return parseInt(window.getComputedStyle(document.body).fontSize, 10);
}

/**
 *
 * @param {number} emValue
 * @param {number} fontSize
 * @return {number}
 */
export function emToPx(emValue, fontSize = BASE_FONT_SIZE_PX) {
  return emValue * fontSize;
}

/**
 *
 * @param {string|number} value
 * @param {number} baseFontSize
 * @return {number|*}
 */
export function unitToPx(value, baseFontSize = BASE_FONT_SIZE_PX) {
  // Convert em unit to px
  if (value !== undefined && value !== null) {
    const matches = value.toString().match(/^(\d+(?:.\d+)?)em$/);
    let computedValue;

    if (matches) {
      computedValue = emToPx(parseInt(matches[1], 10), baseFontSize);
    } else {
      computedValue = parseInt(value, 10);
    }

    return computedValue;
  }

  return value;
}

/**
 *
 * @param value
 * @return {string|}
 */
export function fallbackToPx(value) {
  return (value && typeof value === 'number' && `${value}px`) || value;
}
